export const AGENT_TAB_ORDER = [
  "Prompt",
  "Actions",
  "Knowledge",
  "Model",
  "Display",
];
